<template>
    <div class="columns-2 md:columns-3 gap-4 space-y-4">
        <div
            v-for="(image, index) in gallery"
            @click="handleImageClick(index)"
            :key="`gallery_${image.key}`"
            class="cursor-pointer break-inside-avoid"
        >
            <img
                class="w-full h-auto rounded-lg hover:brightness-95 transition-all"
                :src="`${image.url}?preset=thumb450`"
                alt=""
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import "swiper/swiper-bundle.css";

export type GalleryImage = {
    key: string;
    url: string;
};

export type OpenLightboxFunctionType = (
    index: number,
    gallery: Record<number, GalleryImage>,
) => void;

const props = defineProps({
    gallery: {
        type: Object as () => Record<number, GalleryImage>,
        default: () => ({}),
    },
});

const openLightbox = inject("openLightboxFunction") as OpenLightboxFunctionType;

const handleImageClick = (index: number) => {
    openLightbox(index, props.gallery);
};
</script>
